var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15633",
    "data-name": "Group 15633",
    transform: "translate(12325 1704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15107",
    "data-name": "Group 15107",
    transform: "translate(-12325 -1703.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_628",
    "data-name": "Ellipse 628",
    transform: "translate(0 -0.182)",
    fill: "none",
    stroke: "#ef6286",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14908",
    "data-name": "Group 14908",
    transform: "translate(7.162 8.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M27.732,135.9h0l-3.711-3.694a.71.71,0,0,0-1,1.007l2.492,2.48h-8.8a.71.71,0,1,0,0,1.421h8.8l-2.492,2.48a.71.71,0,0,0,1,1.007l3.711-3.694h0A.711.711,0,0,0,27.732,135.9Z",
    transform: "translate(-16 -132)",
    fill: "#ef6286"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPink);
export default __webpack_public_path__ + "static/media/arrow-pink.69182daf4d8cdbcfe19d39d433944e28.svg";
export { ForwardRef as ReactComponent };